"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.members = exports.methods = exports.initialState = exports.defaultFilters = void 0;
const monocle_ts_1 = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/project/members");
const LightAdminActions = require("../../actionTypes/project/lightAdmin");
const types_1 = require("./types");
const usergroupListReducer = types_1._usergroupListReducer.default('project/members');
const usergroupInviteReducer = types_1._usergroupInviteReducer.default('project/members');
//#region STATE
const createEditInitialState = {
    status: 'NONE',
    isSaving: 'STANDBY',
    error: undefined,
    type: 'NONE',
    name: '',
    description: '',
    id: -1
};
exports.defaultFilters = [
    'FILESTAB',
    'FILESTAB_PLUS',
    'SOKOBID',
    'SOKOSITE'
];
exports.initialState = Object.assign(Object.assign({}, usergroupListReducer.initialState), { invite: Object.assign({}, usergroupInviteReducer.initialState), createEditModal: Object.assign({}, createEditInitialState), currentTab: 0, customer: null, featureFilter: exports.defaultFilters, customers: {
        status: 'STANDBY'
    }, moveUserModal: false, moveUsers: [], moveStatus: 'STANDBY', moveOrCopy: 'MOVE', isSaving: 'STANDBY' });
//#endregion
//#region LENSES
const featureFilterLens = monocle_ts_1.Lens.fromProp('featureFilter');
const currentTabLens = monocle_ts_1.Lens.fromProp('currentTab');
const isSavingLens = monocle_ts_1.Lens.fromProp('isSaving');
const createEditModalLens = monocle_ts_1.Lens.fromProp('createEditModal');
const createEditModalStatusLens = monocle_ts_1.Lens.fromPath(['createEditModal', 'status']);
const createEditModalErrorLens = monocle_ts_1.Lens.fromPath(['createEditModal', 'error']);
const createEditModalIsSavingLens = monocle_ts_1.Lens.fromPath(['createEditModal', 'isSaving']);
const createEditModalNameLens = monocle_ts_1.Lens.fromPath(['createEditModal', 'name']);
const createEditModalDescriptionLens = monocle_ts_1.Lens.fromPath(['createEditModal', 'description']);
const createEditModalIdLens = monocle_ts_1.Lens.fromPath([
    'createEditModal',
    'id'
]);
const createEditModalTypeLens = monocle_ts_1.Lens.fromPath(['createEditModal', 'type']);
const createEditModalNumberLens = monocle_ts_1.Lens.fromPath(['createEditModal', 'siteNumber']);
const createEditModalValidSinceLens = monocle_ts_1.Lens.fromPath(['createEditModal', 'validSince']);
const createEditModalValidUntilLens = monocle_ts_1.Lens.fromPath(['createEditModal', 'validUntil']);
const createEditModalInviteRightsToLens = monocle_ts_1.Lens.fromPath(['createEditModal', 'inviteRightsTo']);
const inviteLens = monocle_ts_1.Lens.fromProp('invite');
const methods = Object.assign({}, usergroupListReducer.methods);
exports.methods = methods;
// State
methods[Actions.CLEAR_STATE] = () => (Object.assign({}, exports.initialState));
methods[Actions.TOGGLE_MOVE_COPY_USER_TO_GROUP] = (state, action) => {
    if (!action.payload.open) {
        return Object.assign(Object.assign({}, state), { moveUserModal: false, selectedGroups: [], selectedUsers: [] });
    }
    return Object.assign(Object.assign({}, state), { moveUserModal: action.payload.open });
};
methods[Actions.MOVE_COPY_USER_TO_USER_GROUP] = (state, action) => (Object.assign(Object.assign({}, state), { moveStatus: 'STANDBY', moveUserModal: !state.moveUserModal, moveOrCopy: action.payload }));
methods[Actions.MOVE_COPY_USER_TO_USER_GROUP_SAVE_REQUEST] = (state, action) => (Object.assign(Object.assign({}, state), { moveStatus: 'SAVING' }));
methods[Actions.MOVE_COPY_USER_TO_USER_GROUP_SAVE_FAILURE] = (state, action) => (Object.assign(Object.assign({}, state), { moveStatus: 'FAILED' }));
methods[Actions.MOVE_COPY_USER_TO_USER_GROUP_SAVE_SUCCESS] = (state, action) => (Object.assign(Object.assign({}, state), { moveStatus: 'SAVED' }));
// User category & user profile
methods[Actions.SET_USER_GROUP_NAME] = (state, action) => createEditModalNameLens.set(action.payload)(state);
methods[Actions.MODIFY_PROJECT_USER_GROUP] = (state, action) => {
    return fp.function.compose(createEditModalStatusLens.set(action.payload.mode), createEditModalNameLens.set(action.payload.name || ''), createEditModalDescriptionLens.set(action.payload.description || ''), createEditModalIdLens.set(action.payload.id), createEditModalTypeLens.set(action.payload.type), createEditModalValidSinceLens.set(action.payload.validSince), createEditModalValidUntilLens.set(action.payload.validUntil), createEditModalNumberLens.set(action.payload.siteNumber), createEditModalInviteRightsToLens.set(action.payload.inviteRightsTo))(state);
};
methods[Actions.DELETE_EDIT] = (state, action) => {
    return fp.function.compose(createEditModalStatusLens.set(action.payload.mode), createEditModalNameLens.set(action.payload.name || ''), createEditModalIdLens.set(action.payload.id), createEditModalTypeLens.set(action.payload.type))(state);
};
// User
methods[Actions.DELETE_USERS_REQUEST] = (state, action) => usergroupListReducer.selectedUsersLens.modify((items) => items.filter((x) => action.payload.items.findIndex((z) => z.user === x.user.id) === -1))(state);
methods[Actions.DELETE_USERS_FROM_PROJECT_SUCCESS] = (state, action) => fp.function.compose(usergroupListReducer.selectedGroupsLens.set([]), usergroupListReducer.selectedUsersLens.set([]))(state);
// User category
methods[Actions.CREATE_CATEGORY_REQUEST] = (state, action) => {
    return fp.function.compose(createEditModalIsSavingLens.set('SAVING'), createEditModalNameLens.set(action.payload.name))(state);
};
methods[Actions.CREATE_CATEGORY_SUCCESS] = (state, action) => {
    return createEditModalIsSavingLens.set('SAVED')(state);
};
methods[Actions.CREATE_CATEGORY_FAILURE] = (state, action) => {
    return fp.function.compose(createEditModalIsSavingLens.set('FAILED'), createEditModalErrorLens.set(action.payload))(state);
};
methods[Actions.UPDATE_CATEGORY_REQUEST] = (state, action) => createEditModalIsSavingLens.set('SAVING')(state);
methods[Actions.UPDATE_CATEGORY_SUCCESS] = (state, action) => createEditModalIsSavingLens.set('SAVED')(state);
methods[Actions.UPDATE_CATEGORY_FAILURE] = (state, action) => {
    return createEditModalIsSavingLens.set('FAILED')(state);
};
// User profile
methods[Actions.CREATE_USER_PROFILE_REQUEST] = (state, action) => {
    return fp.function.compose(createEditModalIsSavingLens.set('SAVING'), createEditModalNameLens.set(action.payload.name))(state);
};
methods[Actions.CREATE_USER_PROFILE_SUCCESS] = (state, action) => {
    return createEditModalIsSavingLens.set('SAVED')(state);
};
methods[Actions.CREATE_USER_PROFILE_FAILURE] = (state, action) => {
    return createEditModalIsSavingLens.set('FAILED')(state);
};
methods[Actions.UPDATE_USER_PROFILE_REQUEST] = (state, action) => createEditModalIsSavingLens.set('SAVING')(state);
methods[Actions.UPDATE_USER_PROFILE_SUCCESS] = (state, action) => createEditModalIsSavingLens.set('SAVED')(state);
methods[Actions.UPDATE_USER_PROFILE_FAILURE] = (state, action) => {
    return createEditModalIsSavingLens.set('FAILED')(state);
};
// Workdiary
methods[Actions.CREATE_WORKSITE_DIARY_REQUEST] = (state, action) => {
    return fp.function.compose(createEditModalIsSavingLens.set('SAVING'), createEditModalNameLens.set(action.payload.name))(state);
};
methods[Actions.CREATE_WORKSITE_DIARY_SUCCESS] = (state, action) => {
    return createEditModalIsSavingLens.set('SAVED')(state);
};
methods[Actions.CREATE_WORKSITE_DIARY_FAILURE] = (state, action) => {
    return fp.function.compose(createEditModalIsSavingLens.set('FAILED'), createEditModalErrorLens.set(action.payload))(state);
};
methods[Actions.UPDATE_WORKSITE_DIARY_FAILURE] = (state, action) => {
    return fp.function.compose(createEditModalIsSavingLens.set('FAILED'), createEditModalErrorLens.set(action.payload))(state);
};
// TRMVRMeter
methods[Actions.CREATE_TRMVRMETER_REQUEST] = (state, action) => {
    return fp.function.compose(createEditModalIsSavingLens.set('SAVING'), createEditModalNameLens.set(action.payload.name))(state);
};
methods[Actions.CREATE_TRMVRMETER_SUCCESS] = (state, action) => {
    return createEditModalIsSavingLens.set('SAVED')(state);
};
methods[Actions.CREATE_TRMVRMETER_FAILURE] = (state, action) => {
    return fp.function.compose(createEditModalIsSavingLens.set('FAILED'), createEditModalErrorLens.set(action.payload))(state);
};
methods[Actions.UPDATE_TRMVRMETER_REQUEST] = (state, action) => createEditModalIsSavingLens.set('SAVING')(state);
methods[Actions.UPDATE_TRMVRMETER_SUCCESS] = (state, action) => createEditModalIsSavingLens.set('SAVED')(state);
methods[Actions.UPDATE_TRMVRMETER_FAILURE] = (state, action) => {
    return fp.function.compose(createEditModalIsSavingLens.set('FAILED'), createEditModalErrorLens.set(action.payload))(state);
};
methods[Actions.DELETE_GROUP_REQUEST] = (state, action) => {
    return isSavingLens.set('SAVING')(state);
};
methods[Actions.DELETE_GROUP_SUCCESS] = (state, action) => {
    return fp.function.compose(usergroupListReducer.selectedGroupsLens.set([]), usergroupListReducer.selectedUsersLens.set([]), isSavingLens.set('SAVED'))(state);
};
methods[Actions.DELETE_GROUP_FAILURE] = (state, action) => {
    return isSavingLens.set('FAILED')(state);
};
// UI
methods[Actions.SET_FEATURE] = (state, action) => featureFilterLens.modify((x) => {
    if (action.payload.status) {
        return action.payload.feature.reduce((acc, item) => {
            if (!acc.includes(item)) {
                acc.push(item);
            }
            return acc;
        }, [...x]);
    }
    return x.filter((z) => !action.payload.feature.includes(z));
})(state);
methods[Actions.DELETE_GROUPS_USERS_SUCCESS] = (state, action) => fp.function.compose(usergroupListReducer.selectedGroupsLens.set([]), usergroupListReducer.selectedUsersLens.set([]))(state);
methods[Actions.SET_TAB] = (state, action) => {
    return fp.function.compose(currentTabLens.set(action.tab), isSavingLens.set('STANDBY'))(state);
};
methods[Actions.TOGGLE_MODAL] = (state) => createEditModalLens.set(Object.assign({}, createEditInitialState))(state);
const handleInvite = (action) => (state) => {
    const fn = usergroupInviteReducer.methods[action.type];
    if (fn) {
        return inviteLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
methods[LightAdminActions.CREATE_LIGHT_ADMIN_REQUEST] = (state, action) => {
    return createEditModalIsSavingLens.set('SAVING')(state);
};
methods[LightAdminActions.EDIT_LIGHT_ADMIN_REQUEST] = (state, action) => {
    return createEditModalIsSavingLens.set('SAVING')(state);
};
methods[LightAdminActions.SAVE_LIGHT_ADMIN_SUCCESS] = (state, action) => {
    return createEditModalIsSavingLens.set('SAVED')(state);
};
methods[LightAdminActions.SAVE_LIGHT_ADMIN_FAILURE] = (state, action) => {
    return fp.function.compose(createEditModalErrorLens.set(action.payload), createEditModalIsSavingLens.set('FAILED'))(state);
};
//#endregion
const handleState = (action) => (state) => {
    const fn = methods[action.type];
    if (fn) {
        return fn(state, action);
    }
    return state;
};
function members(state, action) {
    return fp.function.compose(handleInvite(action), handleState(action))(state);
}
exports.members = members;
//# sourceMappingURL=members.js.map